function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoIsBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 8.4666665 8.4666669",
    height: 32,
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(1.4568288,3.4968546,11.724757)",
    d: "M 6.6363293,7.9853442 4.0833314,6.2649286 1.6521374,8.1164084 2.4994302,5.1567255 -0.01271205,3.4166613 3.0639416,3.3078923 3.9425462,0.38099366 4.99673,3.2734536 8.0518798,3.2045949 5.6267476,5.1010026 Z",
    id: "path837",
    style: {
      fill: "#969696",
      stroke: "none",
      strokeWidth: 1.859,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIsBusiness);
export default __webpack_public_path__ + "static/media/ico-is-business.e7eb0cad.svg";
export { ForwardRef as ReactComponent };